import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const NoResultsBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
});

export const NoResultsBlockMain = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };
});

export const NoResultsBlockMainTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '128%',
    marginBottom: '4px',
  };
});

export const NoResultsBlockMainSubTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.body,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '136%',
    whiteSpace: 'pre-line',
    textAlign: 'center',
  };
});
